import { getMessaging, isSupported } from 'firebase/messaging'
import type { Messaging } from 'firebase/messaging'

import { getBrowserInstallationId } from './getBrowserInstallationId'
import { getFirebaseApp } from './getFirebaseApp'
import { registerNotificationWorker } from './registerNotificationWorker'

type NotificationInfrastructure =
  | { status: 'unsupported'; browserInstallationId: string }
  | {
      status: 'ready'
      browserInstallationId: string
      messaging: Messaging
      registration: ServiceWorkerRegistration
    }

let initialization: Promise<NotificationInfrastructure> | undefined

export const initializeNotifications =
  (): Promise<NotificationInfrastructure> => {
    if (!initialization) {
      initialization = (async () => {
        const browserInstallationId = await getBrowserInstallationId()
        if (!window.isSecureContext || !(await isSupported())) {
          return { status: 'unsupported' as const, browserInstallationId }
        }

        const app = getFirebaseApp()
        const registration = await registerNotificationWorker()
        return {
          status: 'ready' as const,
          browserInstallationId,
          messaging: getMessaging(app),
          registration,
        }
      })().catch((error: unknown) => {
        initialization = undefined
        throw error
      })
    }
    return initialization
  }
